import { Chip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type BlacklistFieldProps = {
  name: string;
  value: any;
  onChange: (value: string[]) => void;
};

const BlacklistField = (props: BlacklistFieldProps) => {
  const handleChange = (e: any, value: string[]) => {
    props.onChange(value);
  };

  return (
    <Autocomplete
      multiple
      id="blacklist"
      options={[]}
      freeSolo
      limitTags={2}
      onChange={handleChange}
      value={props.value || []}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            label={option}
            size="small"
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <EditorVisualTextField
          {...params}
          size="small"
          fullWidth
          name={props.name}
          label="Blacklist"
        />
      )}
    />
  );
};

export default BlacklistField;
